<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'Services'"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="banner_el"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<img src="../../assets/img/service/banner_1.webp" />
					<div class="msg_box">
						<div class="title"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>Services</div>
						<div class="text"
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
						>
							JTESTS offers a variety of detection and analysis services.
						</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--位置-->
			<div class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-icon name="wap-home" class="icon" color="#808080" size="20px" />
				<span @click="goHome" style="cursor: pointer;">Home</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span style="color: #808080;">Services</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						<div class="tit"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>Service Introduction</div>
						<div class="txt"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
						>
							Jtests Clinical Laboratory, based in San Diego, is a leading CLlA-certifed provider of molecular pathology services, specializing in RT-PCR-based tests. Alongside, we offer comprehensive blood and urinary analysis, prioritizing molecular diagnostics. Our competitive edge lies in our innovative research capabilities for IVD product development and provision of raw materials for customer-oriented IVD technology advancement.
						</div>
					</div>
					<div class="right"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="200"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/img/service/block_2.webp" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div>
						Serving Southern California, we're at the forefront of reliable,
					</div>
					<div>
						personalized patient care and transformative diagnostic solutions.
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_box">
						<div class="tit">CLIA Lab Testing</div>
						<div class="txt">
							JTESTS offers a variety of detection and analysis services.
						</div>
					</div>
					<div v-if="servicesList.length > 0" class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div v-for="(value, index) in servicesList" :key="index" class="list_el">
							<div class="img">
								<img :src="weburl + value.thumb" />
							</div>
							<div class="tit">{{ value.name }}</div>
							<div class="txt_box" v-html="value.description"></div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块6-->
			<div class="block_6"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="top_box">
					<div class="top_box_main">
						<div class="tit">Licenses</div>
						<div class="txt">Jtests has obtained authoritative licenses and certificates.</div>
					</div>
				</div>
				<div class="block_6_main">
					<div class="list_box">
						<div class="list_el">
							<img src="../../assets/img/about/honner_1.webp" @click="showImg(require('@/assets/img/about/honner_1.webp'))" />
							<div class="tit">
								Centers For Medicare & Medicaid Services<br />
								Certificate Of Registration
							</div>
						</div>
						<div class="list_el">
							<img src="../../assets/img/about/honner_2.webp" @click="showImg(require('@/assets/img/about/honner_2.webp'))" />
							<div class="tit">
								Clinical And Public Health Laboratory License<br />
								<div style="opacity: 0;">Clinical And Public Health Laboratory License</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块6-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="left"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Leave a message</div>
						<div class="txt">
							Join us in advancing innovative solutions that<br />
							transform lives.
						</div>
					</div>
					<div class="right">
						<contact></contact>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import contact from '@/component/pc/contact.vue'  //联系我们组件
import { ImagePreview } from 'vant';  //图片放大
import { UPURL } from '@/util/util.js';
export default {
	components:{
		navBox,
		footerBox,
		contact
	},
	data() {
		return {
			isLoading: true,  //界面loading
			servicesList: [],
			weburl: '',
		}
	},
	created(){
		let that = this;
		that.weburl = UPURL;
		if(sessionStorage.getItem('navData')) {
			that.servicesList = JSON.parse(sessionStorage.getItem('navData')).service_list;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//处理数据
		initContent(value) {
			return value.split(/\n/);
		},
		goHome() {
			this.$router.push('/');
		},
		//图片放大
		showImg(value) {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [value]
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	//块6
	.block_6{
		.block_6_main{
			width: 1140px;
			margin: 0 auto;
			.list_box{
				padding: 40px 0;
				text-align: center;
				.list_el{
					display: inline-block;
					width: 355px;
					margin: 20px 12px 20px 12px;
					.tit{
						padding-top: 20px;
						font-size: 18px;
						text-align: center;
					}
					img{
						width: 100%;
					}
				}
			}
		}
		.top_box{
			width: 100%;
			max-width: 1920px;
			margin: 0 auto;
			text-align: center;
			background-color: #F6F6F6;
			.top_box_main{
				width: 1140px;
				margin: 0 auto;
				padding: 28px 0 40px 0;
				.txt{
					font-size: 18px;
				}
				.tit{
					font-size: 48px;
				}
			}
		}
	}
	//块4
	.block_4{
		.block_4_main{
			display: flex;
			width: 1140px;
			margin: 0 auto;
			padding: 88px 0 100px 0;
			.right{
				flex: 1;
			}
			.left{
				flex: 1;
				.txt{
					padding-top: 10px;
					font-size: 18px;
				}
				.tit{
					font-size: 40px;
					font-weight: bold;
					color: #006BB3;
				}
			}
		}
	}
	//块3
	.block_3{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		padding: 100px 0 120px 0;
		// background-color: #F6F6F6;
		.block_3_main{
			width: 1140px;
			margin: 0 auto;
			.list_box{
				display: flex;
				padding-top: 40px;
				.list_el:last-child{
					margin-right: 0;
				}
				.list_el{
					flex: 1;
					margin-right: 30px;
					padding: 30px 0 25px 0;
					background-color: #ffffff;
					border: 1px solid #CCCCCC;
					border-radius: 6px;
					.txt_box{
						padding: 0px 30px 0 10px;
					}
					.tit{
						padding: 12px 30px 10px 30px;
						font-size: 28px;
						color: #E37542;
						font-weight: bold;
						text-align: center;
					}
					.img{
						text-align: center;
						img{
							width: 120px;
						}
					}
				}
			}
			.tit_box{
				text-align: center;
				.txt{
					font-size: 18px;
				}
				.tit{
					font-size: 48px;
					font-weight: bold;
				}
			}
		}
	}
	//块2
	.block_2{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		padding: 40px 0;
		background-color: #E37542;
		.block_2_main{
			div{
				font-size: 24px;
				font-weight: bold;
				text-align: center;
				color: #ffffff;
			}
		}
	}
	//块1
	.block_1{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		margin-top: 30px;
		background: url(../../assets/img/service/block_1.webp) no-repeat 100% 100%;
		background-size: cover;
		.block_1_main{
			width: 1140px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			padding: 120px 0;
			.right{
				img{
					width: 480px;
				}
			}
			.left{
				flex: 1;
				padding-right: 140px;
				.txt{
					padding-top: 10px;
					font-size: 18px;
				}
				.tit{
					font-size: 48px;
					font-weight: bold;
				}
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
	//banner
	.banner_box{
		width: 100%;
		max-width: 1920px;
		margin: 0 auto;
		.banner_el{
			position: relative;
			.msg_box{
				width: 100%;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				.text{
					font-size: 24px;
					color: #ffffff;
				}
				.title{
					font-size: 56px;
					color: #ffffff;
				}
			}
			img{
				width: 100%;
				min-width: 1140px;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box ul li{
	padding-bottom: 5px;
}
>>> .main_box img{
	max-width: 100%;
	height: auto;
}
>>> .main_box th{
	padding: 12px;
	background-color: #9F58AE;
	color: #ffffff;
}
>>> .main_box td, >>> .main_box th {
	border: 1px solid #CCCCCC;
	font-size: 16px;
}
>>> .main_box table {
	max-width: 100%;
	border-collapse: collapse;
}
</style>